import { isObject, isArray } from 'lodash-es';
import type {
  NativeAppEventParams,
  WebviewAnalyticsEvent,
  WebviewAnalyticsEventParams,
} from './types';

const wrapIntoObject = (key: WebviewAnalyticsEventParams) => ({
  [String(key)]: '',
});

const buildAnalyticsParams = (
  params: WebviewAnalyticsEvent['params'],
): NativeAppEventParams => {
  if (!params) {
    return {};
  }

  if (!isObject(params)) {
    return wrapIntoObject(params);
  }

  return params as NativeAppEventParams;
};

const buildAnalyticsParamsWithoutArrays = (
  params: WebviewAnalyticsEvent['params'],
) => {
  const baseParams = buildAnalyticsParams(params);

  /**
   * @description As for 29th of August 2024 9% of Android users use
   * old versions of the app (< 3.6.4) that does not support sending arrays in analytics
   *
   * In that case we should skip arrays in params
   */
  return Object.keys(baseParams)
    .filter(key => !isArray(baseParams[key])) // Ignore arrays, don't send that param for analytics
    .reduce((acc, key) => {
      acc[key] = String(baseParams[key]); // Convert all values to string
      return acc;
    }, {} as Record<string, string>);
};

export const webviewLib = {
  buildAnalyticsParams,
  buildAnalyticsParamsWithoutArrays,
};
